import { IEnrichedParticipant, IParticipant } from 'src/interfaces/Participant';
import { IFormRegistration, IRegistration } from 'src/interfaces/Registration';

/**
 * Build the check-in applicant after admin registration create.
 * Always prefer the competition / distance / price / edition just saved in the form
 * so the check-in dialog is prefilled even if the list refetch is stale.
 */
export function resolveCheckinApplicantAfterRegistration(options: {
  participantId: string;
  participant: IParticipant | undefined;
  registrationForm: IFormRegistration;
  editionId: string;
  editionYear?: number;
  refreshed?: IEnrichedParticipant;
}): IEnrichedParticipant {
  const { participantId, participant, registrationForm, editionId, editionYear, refreshed } =
    options;

  const base = refreshed ?? participant;
  const existing = refreshed?.registration;

  const registration: IRegistration = {
    id: existing?.id ?? '',
    participantId,
    editionId,
    competitionId: registrationForm.competitionId,
    distanceId: registrationForm.distanceId,
    price: registrationForm.price ?? existing?.price ?? 0,
    status: existing?.status ?? 'pending',
    year: editionYear ?? existing?.year ?? new Date().getFullYear(),
    gender: participant?.gender ?? refreshed?.gender ?? existing?.gender ?? '',
    ageGroup: existing?.ageGroup ?? '',
    createdAt: existing?.createdAt,
  };

  return {
    ...base,
    id: participantId,
    registration,
  } as IEnrichedParticipant;
}
